import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useCart } from "@/hooks/useCart";

export default function CheckoutPage() {
  const cart = useCart();
  return (
    <div className="min-h-screen bg-background-50 text-foreground-100 flex flex-col">
      <SiteHeader variant="solid" />
      <main className="flex-1 pt-20 md:pt-24">
        <section className="w-full px-6 md:px-10 py-14 md:py-20">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-[10px] tracking-[0.24em] uppercase text-foreground-400 mb-4">Checkout</p>
            <h1 className="text-[28px] md:text-[36px] leading-[1.05] tracking-[-0.01em] text-foreground-50 font-light mb-6">
              Secure checkout coming soon.
            </h1>
            <p className="text-[14px] text-foreground-300 max-w-md mx-auto mb-10">
              This is a template flow. Your bag ({cart.count} item{cart.count === 1 ? "" : "s"}, subtotal ${cart.subtotal}) will be preserved.
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <Link to="/cart" className="px-6 py-3 text-[12px] tracking-[0.15em] uppercase text-foreground-100 border border-background-200/70 rounded-full hover:border-foreground-300 cursor-pointer whitespace-nowrap">
                Back to bag
              </Link>
              <Link to="/shop" className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 text-[13px] rounded-full transition cursor-pointer whitespace-nowrap">
                Keep shopping
              </Link>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}